import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import s from './ErrorBoundary.scss';

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, eventId: null };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		const { debugData = {}, message = '' } = this.props;
		// Display fallback UI
		Sentry.withScope((scope) => {
			scope.setExtras(errorInfo);
			scope.setExtras(debugData);
			Sentry.captureMessage(message);
			const eventId = Sentry.captureException(error);
			this.setState({ eventId });
		});
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className={s.errorBoundary}>
					<h3 className={s.errorBoundary_title}>An error has occurred :/</h3>
					<p className={s.errorBoundary_body}>Please report in as much detail as possible what led to the error. Thanks!</p>
					<button className={s.errorBoundary_button} type="button" onClick={() => Sentry.showReportDialog({ eventId: this.state.eventId })}>Report feedback</button>
				</div>
			);
		}
		return this.props.children || null;
	}
}

export default ErrorBoundary;
